<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a><a id="pv"></a><a id="pvi"></a>
<p class="center ">First Mariner Books edition 2001</p>
<div class="timebreak "> </div>
<p class="center ">Copyright © 1999 by Donna Morrissey</p>
<div class="timebreak "> </div>
<p class="center ">Published by arrangement with Penguin Books Canada Limited</p>
<div class="timebreak "> </div>
<p class="center ">All rights reserved</p>
<div class="timebreak "> </div>
<p class="center ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="center ">
<a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a>
</p>
<div class="timebreak "> </div>
<p class="center "><em>The Library of Congress has cataloged the print edition as follows:</em><br/>
Morrissey, Donna, date.<br/>
Kit’s law / Donna Morrissey.—1 st Mariner Books ed.<br/>
p. cm.<br/>
“A Mariner original.”<br/>
<span class="smallcaps">ISBN</span> 978-0-618-10927-2<br/>
1. Teenage girls—Fiction. 2. Mothers and daughters—Fiction. 3. Mentally ill women—Fiction. 4. Newfoundland—Fiction. I. Title.<br/>
<span class="smallcaps">PR</span>9199.3.<span class="smallcaps">M</span>6535 <span class="smallcaps">K</span>58 2001<br/>
813'.54—dc21 00-065465</p>
<div class="timebreak "> </div>
<p class="center ">e<span class="smallcaps">ISBN</span> 978-0-547-63055-7<br/>
v3.0421</p>
<div class="timebreak "> </div>
<p class="center ">This is a work of fiction. Names, characters, and incidents are the product of the author’s imagination, except in the case of historical figures and events, which are used fictitiously.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?752f8e7d